// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header{
    height: auto;
    position: relative;
    transition: all .3s linear;
    background: rgba(255,255,255,0.7);
    -webkit-backdrop-filter: blur(7px);
    backdrop-filter: blur(7px);
    box-shadow: 0 0 15px #e1e1e1;
}

.header a {
    text-decoration: none;
}

.header .ant-layout{
    background-color: transparent;
    height: 100%;
    padding: 10px 0;
}

.header .ant-layout .ant-row{
      height: 100%;
}

.header__logo{
    display: flex;
    align-items: center;
    font-family: "Oleo Script", cursive;
}

.header__logo a{
    background: -webkit-linear-gradient(#243B55, #141E30);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.header__logo a h1{
    padding: 0;
    margin: 0;
    font-size: 38px;
}

.header__nav{
    height: 100%;
    display: flex;
    column-gap: 20px;
    justify-content: center;
    align-items: center;
    
}

.header__nav a{
    color: #141E30;
    line-height: 1;
    display: inline-block;
    text-transform: uppercase;
    position: relative;
    padding: 10px 20px;
    font-weight: bold;
}

@media screen and (max-width: 1100px) {
    .header__nav a{
        padding: 10px 10px;
    }

    .header__nav{
        column-gap: 10px;
    }

    .header__right::after{
        width: calc(95% + 50px);
    }
}

.header__nav a::after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 40px;
    height: 1px;
    background-color: #141E30;
    box-shadow: 0 0 7px #898989;
    transition: all .1s linear;
    border-radius: 30px;
    opacity: 0;
    transform: scale(0.5) translateX(-100%);
}

.header__nav a:hover::after, .header__nav .active::after{
    transform: scale(1) translateX(-50%);
    opacity: 1;
    transition: all .1s linear;
}

.header__action{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.menu_drawer .ant-drawer-body{
   display: block;
}

.menu_drawer .ant-drawer-body a{
    display: block;
    padding: 10px;
    font-size: 20px;
    border-radius: 5px;
    margin: 1px 0;
    color: #141E30;
}

.menu_drawer .ant-drawer-body a:hover, .menu_drawer .ant-drawer-body a.active{
    font-weight: bold;
    background: linear-gradient(to right, #243B55, #141E30);
    color: white;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/layout/Header.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,iCAAiC;IACjC,kCAAkC;IAClC,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;MACM,YAAY;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,mBAAmB;IACnB,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;GACG,cAAc;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iBAAiB;IAEjB,uDAAuD;IACvD,YAAY;IACZ,qBAAqB;AACzB","sourcesContent":[".header{\n    height: auto;\n    position: relative;\n    transition: all .3s linear;\n    background: rgba(255,255,255,0.7);\n    -webkit-backdrop-filter: blur(7px);\n    backdrop-filter: blur(7px);\n    box-shadow: 0 0 15px #e1e1e1;\n}\n\n.header a {\n    text-decoration: none;\n}\n\n.header .ant-layout{\n    background-color: transparent;\n    height: 100%;\n    padding: 10px 0;\n}\n\n.header .ant-layout .ant-row{\n      height: 100%;\n}\n\n.header__logo{\n    display: flex;\n    align-items: center;\n    font-family: \"Oleo Script\", cursive;\n}\n\n.header__logo a{\n    background: -webkit-linear-gradient(#243B55, #141E30);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.header__logo a h1{\n    padding: 0;\n    margin: 0;\n    font-size: 38px;\n}\n\n.header__nav{\n    height: 100%;\n    display: flex;\n    column-gap: 20px;\n    justify-content: center;\n    align-items: center;\n    \n}\n\n.header__nav a{\n    color: #141E30;\n    line-height: 1;\n    display: inline-block;\n    text-transform: uppercase;\n    position: relative;\n    padding: 10px 20px;\n    font-weight: bold;\n}\n\n@media screen and (max-width: 1100px) {\n    .header__nav a{\n        padding: 10px 10px;\n    }\n\n    .header__nav{\n        column-gap: 10px;\n    }\n\n    .header__right::after{\n        width: calc(95% + 50px);\n    }\n}\n\n.header__nav a::after{\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    width: 40px;\n    height: 1px;\n    background-color: #141E30;\n    box-shadow: 0 0 7px #898989;\n    transition: all .1s linear;\n    border-radius: 30px;\n    opacity: 0;\n    transform: scale(0.5) translateX(-100%);\n}\n\n.header__nav a:hover::after, .header__nav .active::after{\n    transform: scale(1) translateX(-50%);\n    opacity: 1;\n    transition: all .1s linear;\n}\n\n.header__action{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.menu_drawer .ant-drawer-body{\n   display: block;\n}\n\n.menu_drawer .ant-drawer-body a{\n    display: block;\n    padding: 10px;\n    font-size: 20px;\n    border-radius: 5px;\n    margin: 1px 0;\n    color: #141E30;\n}\n\n.menu_drawer .ant-drawer-body a:hover, .menu_drawer .ant-drawer-body a.active{\n    font-weight: bold;\n    background: -webkit-linear-gradient(to right, #243B55, #141E30);\n    background: linear-gradient(to right, #243B55, #141E30);\n    color: white;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
